export default __webpack_public_path__ + "83de51a9aa10371b4fb0c8150474ee4e.png";